import React from "react";
import { useTranslation } from 'react-i18next';
import {ReactComponent as IconCloseBlack} from '../../../../assets/icons/ic-close-black.svg';

const Confirm = ({confirmState}) => {
    const { t } = useTranslation();

    return (
        <div className="absolute inset-0 bg-black bg-opacity-30 flex items-center justify-center z-[9999]">
            <div className="flex flex-col w-[360px] h-[180px] items-start gap-[8px] flex-shrink-0 rounded-[8px] bg-[#DEDEDE] shadow-[0px_12px_12px_0px_rgba(0,0,0,0.60)]">
                <div className="flex h-[38px] px-[12px] pt-[12px] pb-[8px] pl-[20px] justify-between items-center flex-shrink-0 self-stretch bg-[#CECECE] rounded-t-[8px] rounded-b-none">
                    <span className="text-[#000] font-pretendard text-[16px] font-normal leading-[110%] text-center">
                        {confirmState.title}
                    </span>
                    <IconCloseBlack
                        onClick={confirmState.onNo}
                        className="cursor-pointer"
                    />
                </div>
                <div className="flex px-[20px] justify-center items-center gap-[10px] flex-1 self-stretch">
                    <span className="text-left font-pretendard text-[14px] font-medium leading-[110%] text-[#000] whitespace-pre-line">
                        {confirmState.message}
                    </span>
                </div>
                <div className="flex px-[20px] py-[12px] justify-end items-center gap-[8px] self-stretch">
                    <button
                        className="flex w-[88px] h-[28px] px-[8px] py-[7px] justify-center items-center gap-[8px] rounded-[6px] border border-[#B8B8B8] bg-gradient-to-b from-[#FFF] to-[#DEDEDE] text-black text-center font-pretendard text-[16px] font-light leading-[110%]"
                        onClick={confirmState.onNo}
                    >
                        {t('modal.cancel')}
                    </button>
                    <button
                        className="flex w-[88px] h-[28px] px-[8px] py-[7px] justify-center items-center gap-[8px] rounded-[6px] border border-[#5E5E5E] bg-gradient-to-b from-[#5E5E5E] to-[#383838] text-white text-center font-pretendard text-[16px] font-light leading-[110%]"
                        onClick={confirmState.onYes}
                    >
                        {t('modal.ok')}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Confirm;
